(function($) {
  if (!document.querySelector('.page-template-template-before-and-after-local-page')) {
    return;
  }

  const $heroSlider = $('.hero-slider-section .slick-slider');

  if ($heroSlider.length > 0) {
    $heroSlider.slick({
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 8e3,
      speed: 1e3,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
          },
        },
      ],
    });
  }

  const baGallery = document.querySelector('.ba-galleries');
  const baSliders = baGallery.querySelectorAll('.slick-slider');

  if (!baSliders.length) {
    return;
  }

  /**
   * Standard debounce function
   * @param {function} fn - The function to call
   * @param {function} time - How long to wait
   */
  const debounce = (fn, time) => {
    let timeout;

    return function() {
      const functionCall = () => fn.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  };

  /**
   * MutationObserver callback to hide loading styles
   * @param {array} mutationsList - An array of MutationRecord objects, describing each change that occurred
   * @param {function} observer - The MutationObserver which invoked the callback.
   */
  const galleryLoaded = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.matches('.twentytwenty-wrapper')) {
        baGallery.classList.remove('loading');
        observer.disconnect();
        break;
      }
    }
  };

  // Create an observer instance linked to the callback function
  const watchGallery = new MutationObserver(galleryLoaded);

  // Start observing the target node for configured mutations
  watchGallery.observe(baGallery, { childList: true, subtree: true });

  // Init sliders
  baSliders.forEach(slider => {
    const customPrev = slider.parentNode.querySelector('.slick-prev');
    const customNext = slider.parentNode.querySelector('.slick-next');

    $(slider).slick({
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      adaptiveHeight: false,
      draggable: false,
      swipe: false,
      autoplay: true,
      autoplaySpeed: 10000,
      lazyLoad: 'progressive',
      arrows: true,
      prevArrow: customPrev,
      nextArrow: customNext,
    });
  });

  // Re-init jQuery twentytwenty on resize
  window.addEventListener(
    'resize',
    debounce(() => {
      $(baSliders)
        .find("[data-slick-index='0'] .twentytwenty-container")
        .each(function() {
          $(this)
            .find('.twentytwenty-overlay')
            .each(function() {
              $(this).remove();
            });

          $(this)
            .find('.twentytwenty-handle')
            .each(function() {
              $(this).remove();
            });

          $(this).twentytwenty();
        });
    }, 300)
  );
})(jQuery); // Use jQuery for AJAX and Slick Slider
